import Backbone from 'backbone';

import ChartPoint from 'models/chart_point';


export default Backbone.Collection.extend({
  model: ChartPoint
});



// WEBPACK FOOTER //
// ./static/js/collections/chart_data.js